import React, { Component } from 'react';
import ChartDataTable from './ChartDataTable';
import { workRelatedDiseasesTab } from '../../../model/subMenuTabs';
import PrevalenceOfDiseasesChart from '../../common/charts/PrevalenceOfDiseasesChart';
import WorkRelatedDiseasesLineChart from '../../common/charts/WorkRelatedDiseasesLineChart';
import WorkRelatedDiseasesPieChart from '../../common/charts/WorkRelatedDiseasesChart';

class WorkRelatedDiseasesReport extends Component {
    constructor(props){
        super(props);
        this.state = {
            country: this.props.country,
            chartDimension: window.innerWidth > 768 ? 'column' : 'bar'
        }
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (this.props.country != prevState.country)
        {
            this.setState( { country: this.props.country } );
        }
    }

    render(){
        return(
            <React.Fragment>
                {workRelatedDiseasesTab.map(source => {
                    return(
                        <React.Fragment key={source.url}>
                            <h5 className="header4 break-before">{this.props.literals['L'+source.literalTab]}</h5>
                            {
                            source.subTabs.map(secondTab => {
                                return(
                                    <React.Fragment key={secondTab.url}>
                                        <h4 className="header3">{this.props.literals['L'+secondTab.literalTab]}</h4>
                                        {secondTab.subTabs ? secondTab.subTabs.map(thirdTab => thirdTab.chartType.map((chart) => {
                                            let title = this.props.literals[`L${thirdTab.literalTab}`] + ' - ' + chart.type.toUpperCase();
                                            if(secondTab.url == 'prevalence-of-diseases'){
                                                return(
                                                    <div key={`${secondTab.url}-${thirdTab.url}-${chart.type}`} className="box-rounded prevalence--chart">
                                                        <h2 className="title--card" >{title}</h2>
                                                        <PrevalenceOfDiseasesChart
                                                            literals={this.props.literals}
                                                            showSelect={true}
                                                            chartType={thirdTab.chartType}
                                                            //colors={['#f6a300', '#cbe2e3']}
                                                            colors={['#449FA2','#cbe2e3']}
                                                            type={this.state.chartDimension}
                                                            selectedIndicator={chart.type}
                                                            fullCountryReport={true}
                                                            country={this.props.country}
                                                            yAxisMax={chart.yAxisMax}
                                                            step={chart.step}
                                                        />
                                                        <p>{this.props.literals[`L${chart.legend}`]}</p>
                                                        <ChartDataTable
                                                            className='w75 chart-data'
                                                            literals={this.props.literals}
                                                            country={this.props.country}
                                                            chartID={chart.chart}
                                                            split={'dataset'}
                                                            //sameRow={true}
                                                            columns={['Country','Trend', 'Value',]}
                                                            showDecimals={true}
                                                            countryDisplay={'after'}
                                                            illness={chart.illness}
                                                        />
                                                    </div>                                                        
                                                )
                                            }else{
                                                return(
                                                    <div key={`${secondTab.url}-${thirdTab.url}-${chart.type}`} className="box-rounded line--chart">
                                                        <h2 className="title--card" >{title}</h2>
                                                        <WorkRelatedDiseasesLineChart
                                                            chartType={thirdTab.chartType}
                                                            country1={this.state.country}
                                                            country2={'EU27'}
                                                            title={this.props.literals.L20392}
                                                            colors={['#f6a400','#529FA2','#7b7b7d','#ffe300','#449fa2','#f3c564','#16983e','#003399']}
                                                            literals={this.props.literals}
                                                            fullCountryReport={true}
                                                            selectedIndicator={chart.type}
                                                        />
                                                        <p>{this.props.literals[`L${chart.legend}`]}</p>
                                                        <ChartDataTable
                                                            className='w75 chart-data'
                                                            literals={this.props.literals}
                                                            country={this.props.country}
                                                            chartID={chart.chart}
                                                            split={'dataset'}
                                                            //sameRow={true}
                                                            columns={['Country','Trend', 'Value',]}
                                                            showDecimals={true}
                                                            countryDisplay={'after'}
                                                            illness={chart.illness}
                                                        />
                                                    </div>
                                                )
                                            }
                                        })) : secondTab.chartType.map(chartType => {
                                            let title = chartType.type.toUpperCase();
                                            return(
                                                <React.Fragment key={chartType.chart}>
                                                    <div key={chartType.chart} className="breakable-box-rounded pie--chart">
                                                        <h2 className="title--card" >{title}</h2>
                                                        { this.props.country != "EU27_2020" &&
                                                            <WorkRelatedDiseasesPieChart 
                                                                width="659"
                                                                height="500"
                                                                country={{code: this.props.country, name: this.props.literals['L'+this.props.countryName]}}
                                                                chartType={secondTab.chartType}
                                                                diseasesSource={{label: chartType.type.toUpperCase(), value: chartType.type}}
                                                                legend={true}
                                                                legendTitle={chartType.type.toUpperCase()}
                                                                fullCountryReport={true}
                                                            /> 
                                                        }
                                                        <WorkRelatedDiseasesPieChart
                                                            width="659"
                                                            height="500"
                                                            country={{code: "EU27_2020", name: this.props.literals.L822}}
                                                            chartType={secondTab.chartType}
                                                            diseasesSource={{label: chartType.type.toUpperCase(), value: chartType.type}}
                                                            legend={true}
                                                            legendTitle={chartType.type.toUpperCase()}
                                                            fullCountryReport={true}
                                                        />
                                                        <WorkRelatedDiseasesPieChart 
                                                            width="659" 
                                                            height="500"
                                                            country={{code: "GLOBAL", name: this.props.literals.L263}}
                                                            chartType={secondTab.chartType}
                                                            diseasesSource={{label: chartType.type.toUpperCase(), value: chartType.type}}
                                                            legend={true}
                                                            legendTitle={chartType.type.toUpperCase()}
                                                            fullCountryReport={true}
                                                        />
                                                        <ChartDataTable
                                                            className='w75 chart-data'
                                                            literals={this.props.literals}
                                                            country={this.props.country}
                                                            chartID={chartType.chart}
                                                            split={'illness'}
                                                            sameRow={true}
                                                            columns={['Illness','Country', 'Value', 'Country', 'Value', 'Country', 'Value']}
                                                            showDecimals={true}
                                                            countryDisplay={'after'}
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })}
                                    </React.Fragment>
                                )
                            })
                            }
                        </React.Fragment>
                        
                    )
                })}
            </React.Fragment>
        )
    }
}

export default WorkRelatedDiseasesReport;
